module.exports = __webpack_public_path__ + "static/media/20ECE10.12b12bae.jpg";